import {Component, OnInit, Input, Output, EventEmitter, ViewChild, AfterViewInit} from '@angular/core';

import {PatientService} from '../patient.service';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {PatientEditComponent} from '../patient-edit/patient-edit.component';
import {IconRegistryService} from '../../../utilities/icon-registry.service';
import {PatientDialogDataModel} from '../patient-dialog-data.model';
import {ConfirmComponent} from '../../../dialog/confirm-dialog/confirm.component';
import {UiService} from '../../../services/ui.service';
import {DialogService} from '../../../services/dialog.service';
import {DoctorsService} from '../../../services/doctors.service';
import {ContactDataModel} from '../../../models/person/contact-data.model';
import {PatientContactDataModel} from '../../../models/patient/patient-contact-data.model';
import {Globals} from '../../../globals';
import {OrganizationContactDataModel} from '../../../models/organization/organization-contact-data.model';
import {AddressDataModel} from '../../../models/person/address-data.model';
import {ContactCommsDataModel} from '../../../models/person/contact-comms-data.model';
import {Constants} from '../../../constants';
import {TdoAccordionComponent} from '../../../tdo-controls/common/tdo-accordion/tdo-accordion.component';
import {PatientDataModel} from '../../../models/patient/patient-data.model';
import {CommMethodEnum} from '../../../models/enum/comm-method.enum';
import {CommLocationEnum} from '../../../models/enum/comm-location.enum';
import {OrganizationsService} from '../../configuration/organization-configuration/organizations-service';
import { concat } from 'cypress/types/lodash';

@Component({
    selector: 'app-patient-contacts',
    templateUrl: './patient-contacts.component.html',
    styleUrls: ['./patient-contacts.component.css']
})
export class PatientContactsComponent implements OnInit, AfterViewInit {
    @Input() mode: string;
    @Input() entityType: string;
    @Input() data: any[];
    // @Input() patientId: string;
    @Input() doctorId: string;
    @Input() entityId: string;
    // @Input() patient: any;
    @Input() disabled: boolean = false;
    @Input() patient: PatientDataModel;

    @Output() dataChange = new EventEmitter();
    @Output() errorEvent = new EventEmitter();

    @ViewChild('accordion') accordion: TdoAccordionComponent;

    isLoading: boolean = false;
    entityTypeOrganization = PatientDialogDataModel.TYPE_ORGANIZATION;

    mainHomePhoneCommunication: ContactCommsDataModel;
    mainHomeEmailCommunication: ContactCommsDataModel;

    constructor(
        private readonly patientService: PatientService,
        private readonly doctorService: DoctorsService,
        private readonly organizationService: OrganizationsService,
        private readonly dialog: MatDialog,
        private readonly dialogService: DialogService,
        private readonly globals: Globals,
        iconRegistry: IconRegistryService) {
        iconRegistry.registerIcon('contact-card', './assets/icons/icons8-contact-details.svg');
    }

    ngOnInit() {
    }

    ngAfterViewInit(): void {
        if (this.accordion.items.length > 0) {
            this.accordion.items.get(0).isExpanded = true;
        }
        const sub = this.accordion.childItemsUpdate.subscribe((items) => {
            if (items.length > 0) 
                items[items.length - 1].isExpanded = true;
            sub.unsubscribe();
        });
    }

    senddata() {
        this.dataChange.emit(this.data);
    }

    deleteContact(event: MouseEvent, contact: ContactDataModel) {
        event.stopImmediatePropagation();
        this.dialogService.openConfirmDialog('Are you sure you want to delete this contact?').subscribe((result) => {
            if (result) {
                if (this.entityType === PatientDialogDataModel.TYPE_ORGANIZATION){
                    this.organizationService.deleteOrganizationContact(contact.ContactId).subscribe( () => {
                        const idx = this.data.findIndex(p => p.ContactId === contact.ContactId);
                        if (idx > -1) {
                            this.data.splice(idx, 1);
                        }
                    });
                }
                else{
                    this.patientService.deleteContact(contact.ContactId).subscribe(() => {
                        const idx = this.data.findIndex(p => p.ContactId === contact.ContactId);
                        if (idx > -1) {
                            this.data.splice(idx, 1);
                        }
                    });

                }
                this.senddata();
            }
        });
    }

    addNewContact() {
        if (!this.disabled) {
            const sub = this.accordion.childItemsUpdate.subscribe((items) => {
                items[items.length - 1].isExpanded = true;
                sub.unsubscribe();
            });
            if (this.entityType === PatientDialogDataModel.TYPE_PATIENT) {
                const patientContactModel = new PatientContactDataModel();
                patientContactModel.PatientId = this.globals.currentPatientId;
                const model = new ContactDataModel();
                const modelAddress = new AddressDataModel();
                const modelComm = new ContactCommsDataModel();
                patientContactModel.dataContact = model;
                this.data.push(patientContactModel);
            } else if (this.entityType === PatientDialogDataModel.TYPE_ORGANIZATION) {
                const organizationContactModel = new OrganizationContactDataModel();
                organizationContactModel.ContactId = '';
                // organizationContactModel.OrganizationID =
                organizationContactModel.enumOrganizationContactTypeID = '00000264-1000-0000-0000-000000000008';
                const model = new ContactDataModel();
                model.LOCID = parseInt(this.globals.LOCID);
                // model
                // Add phone by default
                // const modelCommPhone = new ContactCommsDataModel();
                // modelCommPhone.CommMethID = CommMethodEnum.Phone;
                // model.dataContactComms.push(modelCommPhone);
                // Add Email by default
                // const modelCommEmail = new ContactCommsDataModel();
                // modelCommPhone.CommMethID = CommMethodEnum.Email;
                // model.dataContactComms.push(modelCommEmail);
                this.mainHomePhoneCommunication = new ContactCommsDataModel();
                this.mainHomePhoneCommunication.enumCommLocationID = CommLocationEnum.WORK;
                this.mainHomePhoneCommunication.enumCommMethodID = CommMethodEnum.Phone;
                this.mainHomePhoneCommunication.LOCID = parseInt(this.globals.LOCID);
                this.mainHomePhoneCommunication.Address = '';
                model.mainPhoneCommunication = this.mainHomePhoneCommunication;
                this.mainHomeEmailCommunication = new ContactCommsDataModel();
                this.mainHomeEmailCommunication.enumCommLocationID = CommLocationEnum.WORK;
                this.mainHomeEmailCommunication.enumCommMethodID = CommMethodEnum.Email;
                this.mainHomeEmailCommunication.LOCID = parseInt(this.globals.LOCID);
                this.mainHomeEmailCommunication.Address = '';
                model.mainEmailCommunication = this.mainHomeEmailCommunication;


                model.dataContactComms.push(this.mainHomePhoneCommunication); // ghone
                model.dataContactComms.push(this.mainHomeEmailCommunication); // ghone
                organizationContactModel.dataContact = model;
                // organizationContactModel.mainEmailCommunication = new ContactCommsDataModel();
                // organizationContactModel.mainPhoneCommunication = new ContactCommsDataModel();


                // this.mainHomePhoneCommunication.ContactId =

                this.mainHomePhoneCommunication = null;
                this.mainHomeEmailCommunication = null;

                this.data.push(model);
            } else {
                this.doctorService.saveDoctorContacts(this.entityId, [new ContactDataModel()]).subscribe((res) => {
                    this.data.push(res[0]);
                    this.senddata();
                });
            }
        }
    }

    openDetailsPageForContact(contact) {
        if (contact.ContactId === undefined) {
            this.patientService.createPatientContact(this.patient.PatientId, contact.dataContact).subscribe((res) => {
                contact.dataContact = res;
                contact.ContactId = res.ContactId;
                this.openPatientDialogModel(contact);
            });
        } else {
            this.openPatientDialogModel(contact);
        }
    }

    openPatientDialogModel(contact: any){
        const dm = new PatientDialogDataModel();
        dm.title = 'Edit Contact';
        dm.mode = PatientDialogDataModel.MODE_EDIT_CONTACT;
        dm.entityType = PatientDialogDataModel.TYPE_PATIENT;
        dm.TheContact = contact.dataContact;
        dm.entity = contact;
        dm.ThePatient = this.patient;
        // dm.ThePatientToCopy = this.patient;
        dm.contacts = contact.dataPatientContacts;

        if (this.entityType === PatientDialogDataModel.TYPE_ORGANIZATION) {
            dm.mode = PatientDialogDataModel.MODE_EDIT_CONTACT;
            dm.entityType = PatientDialogDataModel.TYPE_ORGANIZATION;
            // dm.contacts = [contact];
            dm.TheContact = contact;
        }

        const config = new MatDialogConfig();
        config.width = '968px';
        config.height = '562px';
        config.data = dm;
        config.panelClass = 'tdo-note-dialog-main';

        const dialogRef = this.dialog.open(PatientEditComponent, config);
        dialogRef.afterClosed().subscribe(result => {
            // resolve(result);
        }, err => {
            // reject(err);
        });

    }

    sendError(message) {
        this.errorEvent.emit(message);
    }

  getDateString(d: any) {
        let dateString="";
        if (d) {
            dateString = new Date(d).toLocaleDateString('en-US',  { // you can use undefined as first argument
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
            });
        }
        return dateString;
    }

    getDate(s: string) {
        var zd = new Date();
        if (s) {
            zd = new Date(s);
        }
        else
        {
          zd = new Date('1/1/1800');
        }
        return zd;
    }

    setMainMobilePhoneNumber(contactId: string, $event: any) {
        const phone = this.data.find(x => x.ContactId === contactId).dataContactComms.find(y => y.enumCommMethodID === CommMethodEnum.Phone);
        if (phone) {
            this.data.find(x => x.ContactId === contactId).dataContactComms.find(y => y.enumCommMethodID === CommMethodEnum.Phone).Address  = $event;
        }
        else {
            const newPhone = new ContactCommsDataModel();
            newPhone.enumCommMethodID = CommMethodEnum.Phone;
            newPhone.enumCommLocationID = CommLocationEnum.WORK;
            newPhone.Address = $event;
            this.data.find(x => x.ContactId === contactId).dataContactComms.push(newPhone);
        }
    }

    setIsPreferredMobilePhoneNumber(contactId: string, $event: any) {
        this.data.find(x => x.ContactId === contactId).dataContactComms.find(y => y.enumCommMethodID === CommMethodEnum.Phone).isPreferred = $event;
    }

    setIsPreferredEmail(contactId: string, $event: any) {
        this.data.find(x => x.ContactId === contactId).dataContactComms.find(y => y.enumCommMethodID === CommMethodEnum.Email).isPreferred = $event;
    }

    setMainEmail(contactId: string, $event: any) {
        const email = this.data.find(x => x.ContactId === contactId).dataContactComms.find(y => y.enumCommMethodID === CommMethodEnum.Email);
        if ( email ) {
            this.data.find(x => x.ContactId === contactId).dataContactComms.find(y => y.enumCommMethodID === CommMethodEnum.Email).Address  = $event;
        }
        else {
            const newEmail = new ContactCommsDataModel();
            newEmail.enumCommMethodID = CommMethodEnum.Email;
            newEmail.enumCommLocationID = CommLocationEnum.WORK;
            newEmail.Address = $event;
            this.data.find(x => x.ContactId === contactId).dataContactComms.push(newEmail);
        }
    }

    getMainEmail(contactId: string) {
        if (this.data.find(x => x.ContactId === contactId).dataContactComms.length > 0 && !this.mainHomeEmailCommunication) {
            if ( this.data.find(x => x.ContactId === contactId).dataContactComms.find(y => y.enumCommMethodID === CommMethodEnum.Email)) {
                return this.data.find(x => x.ContactId === contactId).dataContactComms.find(y => y.enumCommMethodID === CommMethodEnum.Email).Address !== null ? this.data.find(x => x.ContactId === contactId).dataContactComms.find(y => y.enumCommMethodID === CommMethodEnum.Email).Address : ''; // = this.mainHomePhoneCommunication.Address;
            }
            else{
                return '';
            }
        } else {
            return '';
        }
    }

    getIsPreferredMobilePhoneNumber(contactId: string) {
        if (this.data.find(x => x.ContactId === contactId).dataContactComms.length > 0 && !this.mainHomePhoneCommunication) {
            if (this.data.find(x => x.ContactId === contactId).dataContactComms.find(y => y.enumCommMethodID === CommMethodEnum.Phone)) {
                return this.data.find(x => x.ContactId === contactId).dataContactComms.find(y => y.enumCommMethodID === CommMethodEnum.Phone).isPreferred; // = this.mainHomePhoneCommunication.Address;
            }
            else{
                return false;
            }

        } else {

            return false; // return this.mainHomePhoneCommunication.isPreferred;
        }
    }

    getIsPreferredEmail(contactId: string) {
        if (this.data.find(x => x.ContactId === contactId).dataContactComms.length > 0 && !this.mainHomeEmailCommunication) {
            if (this.data.find(x => x.ContactId === contactId).dataContactComms.find(y => y.enumCommMethodID === CommMethodEnum.Email)) {
                return this.data.find(x => x.ContactId === contactId).dataContactComms.find(y => y.enumCommMethodID === CommMethodEnum.Email).isPreferred; // = this.mainHomePhoneCommunication.Address;
            }
            else{
                return false;
            }

        } else {

            return false;
        }
    }

    getMainMobilePhoneNumber(contactId: string) {
        if (this.data.find(x => x.ContactId === contactId).dataContactComms.length > 0 && !this.mainHomePhoneCommunication) {
            if (this.data.find(x => x.ContactId === contactId).dataContactComms.find(y => y.enumCommMethodID === CommMethodEnum.Phone)) {
                return this.data.find(x => x.ContactId === contactId).dataContactComms.find(y => y.enumCommMethodID === CommMethodEnum.Phone).Address !== null ? this.data.find(x => x.ContactId === contactId).dataContactComms.find(y => y.enumCommMethodID === CommMethodEnum.Phone).Address : '';
            }
            else {
                return '';
            }

        } else {

            return '';
        }

    }

    protected readonly Date = Date;
}
